import { HugeiconsIcon } from '@hugeicons/react';
import cn from 'classnames';

export const IconCountChip = ({
  icon,
  count = 0,
  backgroundColor = 'bg-primary-4',
  className,
  iconColor = 'text-neutral-6',
}) => (
  <div className={cn('relative flex items-center justify-center p-1', className)}>
    <HugeiconsIcon icon={icon} size={20} strokeWidth={2} className={iconColor} />
    {count > 0 ? (
      <span
        className={cn(
          `absolute -top-1 -right-1 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center ${backgroundColor}`,
        )}>
        {count}
      </span>
    ) : null}
  </div>
);
